import { ref } from 'vue';

export function useAbsenceEmailController() {
  const emailDialogOpen = ref(false);
  const emailDialogData = ref(null);
  // Lokal merken: Für welche Schüler (ID) wurde heute bereits eine Abwesenheitsmail gesendet
  const sentAbsenceEmails = ref([]);

  function firstNameOnly(fullName, fallback) {
    const raw = String(fullName ?? '').trim();
    if (!raw) return String(fallback);

    // Unterstützt auch "Nachname, Vorname"
    if (raw.includes(',')) {
      const parts = raw.split(',').map(s => s.trim()).filter(Boolean);
      const afterComma = parts[1] || '';
      const token = afterComma.split(/\s+/).filter(Boolean)[0];
      return token || String(fallback);
    }

    const token = raw.split(/\s+/).filter(Boolean)[0];
    return token || String(fallback);
  }

  function defaultAbsenceSubject(studentName) {
    const name = firstNameOnly(studentName, 'Schüler/in');
    return `Fehlende Teilnahme von ${name}`;
  }

  function defaultAbsenceMessage(studentName) {
    const name = firstNameOnly(studentName, 'Ihr Kind');

    return [
      'Liebe Eltern,',
      '',
      `${name} ist heute bisher nicht in der Schule angekommen.`,
      'Bitte gebt uns über das Anwesenheitstool eine Meldung zur Abwesenheit.',
      '',
      '<strong>Hinweis</strong>',
      'Diese Nachricht wurde automatisch erstellt, damit ihr die Information zeitnah erhaltet.',
      'Bitte antwortet NICHT auf diese E-Mail.',
      '',
      '',
      'Viele Grüße'
    ].join('\n');
  }

  // UI-Helfer: erkennt, ob bereits eine Abwesenheitsmail für den Schüler gesendet wurde
  function hasAbsenceEmailSent(s) {
    const id = Number(s?.student_id ?? s?.studentId ?? 0);
    const flags = [
      s?.absence_email_sent, s?.absenceEmailSent, s?.email_sent, s?.emailSent,
      s?.absence_notified, s?.notified, s?.parents_notified, s?.parentsNotified
    ];
    return (id && sentAbsenceEmails.value.includes(id)) ||
      flags.some(v => v === true || v === 1 || v === '1' || v === 'true');
  }

  function openAbsenceMailDialog(s) {
    const parents = Array.isArray(s?.parents) ? s.parents : [];
    const recipients = parents.map(p => ({
      userId: Number(p.userId ?? p.id ?? 0),
      name: String(p.name ?? '').trim(),
      email: String(p.email ?? '').trim()
    })).filter(r => r.userId > 0 && r.email);

    emailDialogData.value = {
      studentId: Number(s?.student_id ?? s?.studentId ?? 0),
      recipients,
      preselectedRecipientUserIds: recipients.map(r => r.userId),
      subject: defaultAbsenceSubject(s?.student_name || s?.studentName),
      message: defaultAbsenceMessage(s?.student_name || s?.studentName)
    };
    emailDialogOpen.value = true;
  }

  // Nach erfolgreichem Versand aufgerufen; markiert lokal, schließt Dialog und gibt die Student-ID zurück
  function handleEmailSent() {
    const sid = Number(emailDialogData.value?.studentId ?? 0);
    if (sid && !sentAbsenceEmails.value.includes(sid)) {
      sentAbsenceEmails.value = [...sentAbsenceEmails.value, sid];
    }
    emailDialogOpen.value = false;
    emailDialogData.value = null;
    return sid;
  }

  return {
    emailDialogOpen,
    emailDialogData,
    hasAbsenceEmailSent,
    openAbsenceMailDialog,
    handleEmailSent
  };
}
